module.exports = __webpack_public_path__ + "img/bg3.d83acaca.png";